<template>
    <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
        <div class="kgr-grid__cell">
            <kgr-member-part-basic
                :member-short-profile="memberShortProfile"
                class="kgr-row kgr-row--bigMargin"
            />

            <kgr-member-part-contact
                :member-short-profile="memberShortProfile"
                class="kgr-row kgr-row--bigMargin"
            />

            <kgr-member-part-honors
                :member-short-profile="memberShortProfile"
                class="kgr-row kgr-row--bigMargin"
            />

            <kgr-member-part-relations :member-short-profile="memberShortProfile" />
        </div>

        <div class="kgr-grid__cell">
            <kgr-member-part-payment-information :member-short-profile="memberShortProfile" />
            <kgr-member-part-membership :member-short-profile="memberShortProfile" />
            <kgr-member-part-offering-bookings :member-short-profile="memberShortProfile" />
            <kgr-member-part-comments :member-short-profile="memberShortProfile" />
        </div>
    </div>
</template>

<script>
import KgrMemberPartBasic from './short-profile-parts/MemberPartBasic';
import KgrMemberPartComments from './short-profile-parts/MemberPartComments';
import KgrMemberPartContact from './short-profile-parts/MemberPartContact';
import KgrMemberPartHonors from './short-profile-parts/MemberPartHonors.vue';
import KgrMemberPartMembership from './short-profile-parts/MemberPartMembership';
import KgrMemberPartOfferingBookings from './short-profile-parts/MemberPartOfferingBookings';
import KgrMemberPartPaymentInformation from './short-profile-parts/MemberPartPaymentInformation.vue';
import KgrMemberPartRelations from './short-profile-parts/MemberPartRelations';
import MemberShortProfile from '../../js/dto/MemberShortProfile';

export default {
    name: 'KgrMemberShortProfile',
    components: {
        KgrMemberPartBasic,
        KgrMemberPartComments,
        KgrMemberPartContact,
        KgrMemberPartHonors,
        KgrMemberPartMembership,
        KgrMemberPartOfferingBookings,
        KgrMemberPartPaymentInformation,
        KgrMemberPartRelations,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
